var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "status-display d-flex flex-column align-items-center"
  }, [_vm._v(" " + _vm._s(_vm.message) + " "), _c('div', {
    staticClass: "text-center p-3"
  }, [_vm.iconType === 'success' ? _c('i', {
    staticClass: "fa fa-check-circle-o fa-5 text-success"
  }) : _vm._e(), _vm.iconType === 'error' ? _c('i', {
    staticClass: "fa fa-times-circle-o fa-5 text-danger"
  }) : _vm._e(), _vm.iconType === 'question' ? _c('i', {
    staticClass: "fa fa-question-circle-o fa-5 text-secondary"
  }) : _vm._e(), _vm.iconType === 'info' ? _c('i', {
    staticClass: "fa fa-info-circle fa-5 text-info"
  }) : _vm._e(), _vm.iconType === 'warning' ? _c('i', {
    staticClass: "fa fa-exclamation-circle fa-5 text-warning"
  }) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }